import { useEffect, useRef } from "react";
import { ModelService } from "@/services/ModelService";
import { isOfferPreparing } from "@/utils/offerPreparation";

const useOfferPreparationPolling = (offers, onUpdate, intervalMs = 5000) => {
    const onUpdateRef = useRef(onUpdate);
    onUpdateRef.current = onUpdate;

    const preparingIds = (offers ?? []).filter(isOfferPreparing).map((o) => o.id).join(",");

    useEffect(() => {
        if (!preparingIds) return undefined;
        let stopped = false;

        const tick = () => preparingIds.split(",").forEach(async (id) => {
            try {
                const s = await ModelService.getOfferPreparation(id);
                if (!stopped) onUpdateRef.current(id, { preparationStatus: s?.status, preparationProgress: s?.progress });
            } catch {
            }
        });

        const timer = setInterval(tick, intervalMs);
        return () => {
            stopped = true;
            clearInterval(timer);
        };
    }, [preparingIds, intervalMs]);
};

export default useOfferPreparationPolling;
